import clsx from 'clsx'

export function Container({
  className,
  children,
  ...props
}: {
  className?: string
  children: any
  props?: any
}) {
  return (
    <div className={clsx('mx-auto max-w-7xl px-8', className)} {...props}>
      {children}
    </div>
  )
}
